module.exports = __webpack_public_path__ + "img/47.cd99c739.jpeg";